
import { computed, defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// composable
import { RPKT } from '@/core/types/rpk.types'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<RPKT>,
            required: true,
        },
    },
    emits: ['delete'],
    setup(props, { emit }) {
        const getStatusColor = (id: number) => {
            if (id === 13) return 'primary'
            if (id === 15) return 'green'
            if (id === 11) return 'yellow'

            return ''
        }

        const getTakeDate = () => {
            return `${props.item.take_date}, ${props.item.take_time}` || 'Нет данных'
        }

        const formatCost = (cost: number) => {
            return cost.toLocaleString().split(',').join(' ')
        }

        const getCost = computed(() =>
            props.item.cost_total ? `${formatCost(props.item.cost_total)} ₸` : 'Нет данных'
        )
        const getCostTitle = computed(() => {
            const str = 'Сумма'
            if (props.item.type_id === 1 || props.item.type_id === 8) {
                return props.item.cost_price_with_nds ? `${str} (с НДС)` : `${str} (без НДС)`
            }
            if (props.item.type_id !== 6) return `${str}`

            return props.item.cost_price_with_nds ? `${str} (с НДС)` : `${str} (без НДС)`
        })

        const emitDelete = () => {
            const answer = confirm(`Вы действительно хотите удалить РПК (ID: ${props.item.id})?`)

            if (!answer) return

            emit('delete', props.item.id)
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        return { getStatusColor, getTakeDate, getCost, getCostTitle, emitDelete, formatDate }
    },
})
